import { render } from "./FormTBTH2024.vue?vue&type=template&id=40c57dbe&scoped=true"
import script from "./FormTBTH2024.vue?vue&type=script&lang=js"
export * from "./FormTBTH2024.vue?vue&type=script&lang=js"

import "./FormTBTH2024.vue?vue&type=style&index=0&id=40c57dbe&lang=scss&scoped=true"

import exportComponent from "/DATA/REPO/survey-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c57dbe"]])

export default __exports__